var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.show,"z-index":"100"}},[_c('v-progress-circular',{attrs:{"size":80,"color":"spinner","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }